import { Suspense } from 'react';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import { Dashboard } from '@modules/Dashboard/views/Dashboard';


export const DashboardPage = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%"/>}>
        <Dashboard/>
      </Suspense>
    </ErrorBoundary>
  );
};
